/**
 * Mirrors the router's location into core/route-state.ts and, when asked,
 * tells the shell about it. Rendered inside whichever router a shell uses
 * (BrowserRouter on the web, MemoryRouter when embedded), so it is the one
 * place both shells learn "which board is on screen" from.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { noteRoute } from "./route-state.js";

export interface RouteReporterProps {
  onChange?: ((path: string) => void) | undefined;
}

export function RouteReporter({ onChange }: RouteReporterProps) {
  const location = useLocation();
  const path = `${location.pathname}${location.search}`;
  useEffect(() => {
    noteRoute(path);
    onChange?.(path);
  }, [path, onChange]);
  return null;
}
